import React from "react";
import { getSiteMode } from "../utils/siteMode";
import { Zap, Sparkles } from "lucide-react";

// Custom Linear icon built to seamlessly match Lucide's line-drawn aesthetic
const LinearWorkflowIcon = ({ size, strokeWidth, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" style={style}>
    <rect x="2" y="9.5" width="5" height="5" rx="1" />
    <line x1="7" y1="12" x2="9.5" y2="12" />
    <rect x="9.5" y="9.5" width="5" height="5" rx="1" />
    <line x1="14.5" y1="12" x2="17" y2="12" />
    <rect x="17" y="9.5" width="5" height="5" rx="1" />
  </svg>
);

const STATS = [
  { 
    icon: Zap,
    value: "GPU-Accelerated", 
    label: "Cloud basecalling infrastructure" 
  },
  {
    icon: Sparkles,
    value: "Exclusive Models",
    label: "Proprietary architectures unavailable elsewhere",
  },
  {
    icon: LinearWorkflowIcon,
    value: "End-to-End",
    label: "Upload, analyze, visualize, and share in one platform",
  },
];

const TrustSection = () => {
  const mode = getSiteMode();

  return (
    <section className="trust-section">
      <div className="container">
        <div className="features-header">
          <h2 className="features-title">
            Built for nanopore researchers by nanopore researchers
          </h2>
          <p className="features-subtitle">
            Designed by scientists who understand sequencing workflows from the
            ground up.
          </p>
        </div>

        <div className="trust-grid">
          {STATS.map((s, i) => {
            const Icon = s.icon;
            return (
              <div key={i} className="trust-card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <Icon size={32} strokeWidth={1.5} style={{ marginBottom: '16px', color: '#112D4E' }} />
                <div className="trust-value">{s.value}</div>
                <div className="trust-label">{s.label}</div>
              </div>
            );
          })}
        </div>

        {mode === "dev" && (
          <div className="trust-logos">
            <p className="trust-logos-label">Trusted by early pilot partners</p>
            <div className="trust-logos-row">
              <span className="trust-logo-placeholder">Partner 1</span>
              <span className="trust-logo-placeholder">Partner 2</span>
              <span className="trust-logo-placeholder">Partner 3</span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default TrustSection;
